<template>
    <div>
        <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">考勤组管理</div>
        <el-row style="margin-top: 9px;">
            <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px;">

                <el-row style="padding-left: 46px; padding-top: 40px;">

                    <el-col :span="5">
                        <span>考勤组名称</span>
                        <el-input v-model="condition.checkAttendance_name" placeholder="请输入名称" style="width: 60%; margin-left: 10px;">
                        </el-input>
                    </el-col>

                    <el-col :span="10">
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Find">
                            查询</el-button>
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Del(null)">
                            删除</el-button>
                        <el-button style="width: 85px; border: 1px solid #006E4B; color: #006E4B;" @click="AddForm">
                            新增</el-button>
                    </el-col>
                </el-row>
                <el-row style="margin: 0px 2%; margin-top: 10px;">
                    <el-row>
                        <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                            :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" height="590"
                            tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55">
                            </el-table-column>
                            <el-table-column align="center" label="序号" width="80">
                                <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                            </el-table-column>
                            <el-table-column prop="checkAttendance_name" align="center" label="考勤组名称"></el-table-column>
                            <el-table-column prop="work_shift" align="center" label="上班时间"></el-table-column>
                            <el-table-column prop="closing_time" align="center" label="下班时间"></el-table-column>
                            <el-table-column prop="restStart_time" align="center" label="休息开始时间"></el-table-column>
                            <el-table-column prop="restEnd_time" align="center" label="休息结束时间"></el-table-column>
                            <el-table-column align="center" label="出勤人">
                                <template slot-scope="scope">
                                    <el-button
                                        style="background-color: #FFFFFF; border: 1px #006E4B solid; color: #006E4B;" @click="StaffFind(scope.row.attendants, 1, 10)">
                                        查看出勤人</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" label="操作">
                                <template slot-scope="scope">
                                    <img src="../../../assets/编辑.png" @click="EditForm(scope.row)" />
                                    <img src="../../../assets/删除.png" @click="Del(scope.row.id)" />
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row>
                    <el-row style="margin-top: 10px; text-align: center;">
                        <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                            layout=" prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </el-row>
                </el-row>
            </div>
        </el-row>

        <el-dialog :title="form.id != null && form.id != '' ? '修改' : '新增'" center :visible.sync="dialogVisible"
            width="30%" :close-on-click-modal="false">
            <add ref="add"></add>
        </el-dialog>
        
        <el-dialog title="出勤人" center :visible.sync="staffFindVisible"
            width="40%">
            <staffFind ref="staffFind" :attendantsData="attendantsData" :idString="idString"></staffFind>
        </el-dialog>

    </div>
</template>

<script>
    import axios from "axios";
    import add from "./KqzGl_add.vue";
    import staffFind from "./KqzGl_StaffFind.vue";
    export default {
        components: {
            add: add,
            staffFind: staffFind,
        },
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                //条件
                condition: {
                    checkAttendance_name: "",
                },

                //详情
                form: {
                    id: "",
                    checkAttendance_name: "",
                    work_shift: "",
                    closing_time: "",
                    restStart_time: "",
                    restEnd_time: "",
                    attendants: "",
                    attendants_name: "",
                },
                
                //出勤人
                attendantsData: [],
                //出勤人ids
                idString: "",

                //页面相关
                dialogVisible: false,
                staffFindVisible: false,

                //复选框ids
                ids: [],
            };
        },
        methods: {
            //查询出勤人
            async StaffFind(e, num, size){
                this.idString = e;
                var attendantsData = await this.$globals.AxiosPost("staff/selectWhole", {
                    idString: e,
                    page_num: num,
                    page_size: size
                });
                this.attendantsData = attendantsData.data;
                
                this.staffFindVisible = true;
            },
            //返回
            Return() {
                this.dialogVisible = false;
                this.trash();
                this.Find();
            },
            //列表点击复选框
            handleSelectionChange(e) {
                this.ids = [];
                e.forEach(item => {
                    this.ids.push(item.id);
                })
            },
            //查询
            async Find() {
                var url = 'attendanceGroup/find';
                var record = {
                    page_num: this.page_num,
                    page_size: this.page_size,
                    checkAttendance_name: this.condition.checkAttendance_name,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.tableData = data.list;
                        this.total = data.total;
                    } else {
                        this.$message.warning('请求失败！请稍后重试');
                    }
                }
            },
            //分页
            handleCurrentChange(e){
                this.page_num = e;
                this.Find();
            },
            //新增页面
            AddForm() {
                this.dialogVisible = true;
                this.trash();
            },
            //详情页面
            EditForm(e) {
                this.form.id = e.id;
                this.form.checkAttendance_name = e.checkAttendance_name;
                this.form.work_shift = e.work_shift;
                this.form.closing_time = e.closing_time;
                this.form.restStart_time = e.restStart_time;
                this.form.restEnd_time = e.restEnd_time;
                this.form.attendants = e.attendants;
                this.form.attendants_name = e.attendants_name;
                this.dialogVisible = true;
            },
            //删除
            async Del(e) {
                var ids;
                if (e === null || e === "" || e === undefined) {
                    if (this.ids === null || this.ids.length <= 0) {
                        this.$message.warning("请先选择操作数据！");
                        return false;
                    }
                    ids = this.ids;
                } else {
                    ids = [e];
                }

                var url = "attendanceGroup/del";
                var record = {
                    ids: ids,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === "-2000") {
                    this.$message.error("服务器未响应！请稍后重试");
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.trash();
                        this.Find();
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
            //清除数据
            trash() {
                this.form.id = "";
                this.form.checkAttendance_name = "";
                this.form.work_shift = "";
                this.form.closing_time = "";
                this.form.restStart_time = "";
                this.form.restEnd_time = "";
                this.form.attendants = "";
                this.form.attendants_name = "";
            },
        },
        created() {
            this.Find();
        }
    }
</script>

<style scoped="scoped">
    >>>.el-button:hover {
        background-color: #FFFFFF;
    }

    >>>.el-button:focus {
        background-color: #FFFFFF;
    }

    >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #006E4B;
    }

    >>>.el-input__inner:focus {
        border-color: #006E4B;
    }

    >>>.el-select .el-input.is-focus .el-input__inner {
        border-color: #006E4B;
    }

    >>>.el-checkbox__input.is-checked .el-checkbox__inner,
    >>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-checkbox__inner:hover {
        border-color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// KqzGl.vue?efebce4e